export default __webpack_public_path__ + "static/media/Icon awesome-shopping-cart.c06b61a2.svg";